export const readNumericValue = (value, fallback = 0) => {
  if (value == null || value === "") return fallback;
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : fallback;
  }
  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }
  if (typeof value === "object") {
    if (value.parsedValue != null && value.parsedValue !== "") {
      return readNumericValue(value.parsedValue, fallback);
    }
    if (typeof value.source === "string" && value.source !== "") {
      const parsed = parseFloat(value.source);
      return Number.isNaN(parsed) ? fallback : parsed;
    }
  }
  return fallback;
};

export const normalizeProductId = (value) =>
  value == null || value === "" ? null : String(value);

export const isProductRecord = (value) =>
  Boolean(
    value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      ("id" in value || "product_name" in value || "name" in value)
  );

export const extractProducts = (responseData) => {
  const unwrap = (data) => {
    if (!data) return [];

    if (Array.isArray(data)) {
      return data.filter(isProductRecord);
    }

    if (typeof data !== "object") return [];

    const nestedKeys = ["outputrecords", "data", "result", "records", "products"];
    for (const key of nestedKeys) {
      if (data[key] != null) {
        const nested = unwrap(data[key]);
        if (nested.length) return nested;
      }
    }

    const values = Object.values(data);
    if (values.length && values.every(isProductRecord)) {
      return values;
    }

    return [];
  };

  return unwrap(responseData);
};

export const findProductById = (productList, productId) => {
  const normalizedId = normalizeProductId(productId);
  if (!normalizedId || !Array.isArray(productList)) return null;
  return (
    productList.find((prod) => normalizeProductId(prod.id) === normalizedId) || null
  );
};

export const getProductTokenCount = (product) => {
  if (!product) return 0;

  const candidates = [
    product.number_of_tokens,
    product.number_of_token,
    product.x_numberoftokens,
    product.tokens,
    product.token_quantity
  ];

  for (const candidate of candidates) {
    const value = readNumericValue(candidate, NaN);
    if (!Number.isNaN(value)) return value;
  }

  return 0;
};

export const getProductDisplayName = (product) =>
  product?.product_name || product?.name || "Product";
